<template>
    <div class="mx-md-5 my-4">
        <div class="container-fluid w-100">
            <!-- <div class="notification-list mb-2">
                <button class="btn btn-primary shadow btnl" @click="addRole">
                    <i class="fas fa-solid fa-plus"></i>Nouveau rôle
                </button><br>
            </div> -->
            <div class="pt-5 d-md-flex w-100 flex-wrap">
                <div class="mr-md-auto mt-2">
                    <h2 class="default fwb">Liste des utilisateurs </h2><br>
                </div>
                <div class="ml-md-auto float-right">
                    <ul class="list-none p-0 d-md-flex align-items-end gap-2 float-right">
                        <b-form-group>
                            <input type="text" v-model="search" @keyup="searchUser($event)" class="form-control" placeholder="rechercher une plainte ou un patient">
                        </b-form-group>
                    </ul>
                </div>
            </div>
            <div class="">
                <div class="bg-transparent d-none d-md-block">
                    <div class="rounded taille mb--3 align-items-center">
                        <ul
                            class="list-none px-2 py-2 row-lg table-header gap-2 justify-content-between d-flex align-items-center">
                            <li class="col-lg nom">Noms</li>
                            <li class="col-lg nom">Rôle</li>
                            <li class="col-lg d-none d-lg-block">Actions</li>
                        </ul>
                    </div>
                    <div :class="mouse ? 'rounded mb-1 align-items-center cursor hoverTd' : 'rounded bg-white mb-1 align-items-center cursor'"
                        @mouseleave="mouse = false" @mouseover="mouse = true" v-for="user in users.data" :key="user.id">
                        <div @click="voirUser(user.slug)">
                            <ul class="list-none d-flex row-lg default fwn px-2 py-3 mb-2 gap-2 justify-content-between align-items-center"
                                id="modalTC">
                                <li class="col-lg d-flex align-items-center gap-1">
                                    <span class="m-0 fwb">{{ user.name }}</span>
                                </li>
                                <li class="col-lg d-flex align-items-center gap-1">
                                    <span class="m-0 fwb">{{ user.roles[0].name }}</span>
                                </li>
                                <li class="col-lg d-flex align-users-center">
                                    <span size="sm" class="border-right text-primary cursor border-5 pr-2"
                                        @click="voirUser(user.slug)">
                                        <span class="voir-role"><i class="fa fa-eye mr-1"></i>voir</span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <ModalRole :modal_id="'modal-xl-' + user.id" :role="user" />

                    </div>
                    
                </div>
                <div>
                    <div class="mt-3" v-if="users.data">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination justify-content-end" id="pagination-demo">
                                <li :class="`page-item ${users.current_page == users.from ? 'disabled' : ''}`"><a class="page-link" href="#" @click="previous(users.current_page)" tabindex="-1" aria-disabled="true"> <span aria-hidden="true">&laquo;</span>
                                    <span class="sr-only">Previous</span></a>
                                </li>
                                <li :class="`page-item ${users.current_page == n ? 'active' : ''}`" v-for="n in pages" :key="n" @click="changePage(n)"><a class="page-link" href="#">{{ n }}</a></li>
                                <span class="page-item">
                                    <li :class="`page-item ${users.current_page == users.last_page ? 'disabled' : ''}`"><a class="page-link" href="#" @click="next(users.current_page)" tabindex="-1" aria-disabled="true"> <span aria-hidden="true">&raquo;</span>
                                        <span class="sr-only">Next</span></a>
                                    </li>
                                </span>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import router from '../../router/router';
import { mapGetters, mapState } from "vuex";
import Multiselect from 'vue-multiselect';
import ModalRole from "./ModalRole.vue";
import DeleteRole from "./DeleteRole.vue";
export default {
    name: "MoreAppointments",

    components: {
        Multiselect,
        ModalRole,
        DeleteRole
    },
    computed: {
        ...mapGetters(["roles", "permissions", 'hasAdminRole', 'users']),
        pages() {
            let numShown = 6;   // This sets the number of page tabs
            numShown = Math.min(numShown, this.users.last_page);
            let first = this.users.current_page - Math.floor(numShown / 2);
            first = Math.max(first, 1);
            first = Math.min(first, this.users.last_page - numShown + 1);
            return [...Array(numShown)].map((k, i) => i + first);
        },
    },

    data() {
        return {
            mouse: false,
            name: '',
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            load: true,
            moreDetails: true,
            loading: false,
            role: {},
            user: {},
            Home: false,
            mobileView: true,
            search: "",
            roleState: null,
            submittedNames: []
        }
    },

    methods: {
        addRole() {
            this.$nextTick(() => {
                this.$bvModal.show('modal-prevent-closing')
            })
        },
        closeModal() {
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },
        // getUsersWithRoles
        // getUsersWithRoles() {
        //     let args = {
        //         offset: this.offset,
        //         limit: this.limit,
        //     };

        //     this.$store.dispatch("getUsersWithRoles", { args: args });
        // },
        getUsersWithRoles(page = 1, search = "", size = 10) {
            let args = {
                page: page,
                search: search,
                size: size,
            };

            this.$store.dispatch('getUsersWithRoles', { args: args });
        },
        previous(page) {
            page--
            this.getUsersWithRoles(page, "", 10);
        },
        next(page) {
            page++
            this.getUsersWithRoles(page, "", 10);
        },
        changePage(page) {
            this.getUsersWithRoles(page, "", 10);
        },
        getRoles() {
            let args = {
                offset: this.offset,
                limit: this.limit,
            };

            this.$store.dispatch("getRoles", { args: args });
        },
        getPermissions() {
            let args = {
                offset: this.offset,
                limit: this.limit,
            };

            this.$store.dispatch("getPermissions", { args: args });
        },
        voirUser(slug) {
            router.push({ name: 'view-users-details', params: { id: slug } });
        },

        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.roleState = valid
            return valid
        },
        resetModal() {
            this.name = ''
            this.roleState = null
        },
        DeleteRole(user) {
            // console.log(user);
            this.user = user;
            this.$bvModal.show("delete-modal");
        },
        searchUser(event) {
            if (event.target.value.length > 2) {
                this.getUsersWithRoles(1, event.target.value, 10);
            } else if (event.target.value == "") {
                this.getUsersWithRoles(1, "", 10 );
            }
        },
        // handleOk(bvModalEvent) {
        //     // Prevent modal from closing
        //     bvModalEvent.preventDefault()
        //     // Trigger submit handler
        //     this.handleSubmit()
        // },
        handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                console.log(this.name);
                return
            }
            // console.log(this.name);
            let args = {
                name: this.name,
            }
            // console.log(args);
            let successMessage = this.$i18n.t('message.RoleCreated');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.error')
            };

            this.$store.dispatch('createRole', { args, errorMessages, successMessage })
                .then(() => {
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                });
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        }

    },
    mounted() {
        this.getRoles();
        this.getUsersWithRoles();
        // this.getPermissions();
    },
}
</script>
<style lang="scss">
.hoverTd:hover {
    background-color: #2dcecc;

    li {
        color: white;
    }

    span {
        color: white;
    }

    .voir-role {
        color: white;
    }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>